import { Divider, ListItemIcon, ListItemText, Menu, MenuItem, MenuProps } from '@mui/material';
import { ReactNode } from 'react';

type ActionItemProps = {
  name?: string;
  onClick?: () => void;
  icon?: ReactNode;
};

type Props = MenuProps & {
  items: ActionItemProps[];
};

export const ActionMenu = (props: Props) => {
  return (
    <Menu {...props}>
      {props.items.map(({ name, onClick, icon }, index) =>
        name ? (
          <MenuItem key={index} onClick={onClick}>
            {icon && <ListItemIcon>{icon}</ListItemIcon>}
            <ListItemText>{name}</ListItemText>
          </MenuItem>
        ) : (
          <Divider />
        )
      )}
    </Menu>
  );
};
